import React from "react";

const Bookmarks: React.FC = () => {
  return <h1>Bookmarks Page</h1>;
};

export default Bookmarks;
